import React from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useEventsContext } from "../EventsContext/EventsContext";
import EventFilterForm from "./EventFilterForm";

const EventMobileFilters = () => {
  const { showFilterModal, handleCloseFilterModal } = useEventsContext();
  return (
    <>
      <Offcanvas
        show={showFilterModal}
        onHide={handleCloseFilterModal}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Offcanvas</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <EventFilterForm />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default EventMobileFilters;
